import { version } from '../../../package.json';

export const environment = {
    appVersion: version,
    production: false,
    apiUrl: 'https://app-api-aglet-qa-eastus2.azurewebsites.net',
    environment: 'QA'
};
